/*---------------------------------------------------------------------------------------------

@author       Constantin Saguin - @brutaldesign
@link            http://csag.co
@github        http://github.com/brutaldesign/swipebox
@version     1.2.1
@license      MIT License

----------------------------------------------------------------------------------------------*/

;(function (window, document, $, undefined) {
	
	$.swipebox = function(elem, options) {

		var defaults = {
			useCSS : true,
			initialIndexOnArray : 0,
			hideBarsDelay : 3000,
			videoMaxWidth : 1140,
			vimeoColor : 'CCCCCC',
			beforeOpen: null,
		      	afterClose: null
		},
		index,
		plugin = this,
		elements = [], // slides array [{href:'...', title:'...'}, ...],
		elem = elem,
		selector = elem.selector,
		$selector = $(selector),
		isTouch = document.createTouch !== undefined || ('ontouchstart' in window) || ('onmsgesturechange' in window) || navigator.msMaxTouchPoints,
		supportSVG = !!(window.SVGSVGElement),
		winWidth = gon.winWidth,
		winHeight = gon.winHeight,
		html = '<div id="swipebox-overlay"><div id="swipebox-caption"><div id="controls-container"><a id="swipebox-prev"></a><a id="swipebox-next"></a><div id="close-box"><a id="swipebox-close"></a></div></div></div><div id="swipebox-slider"></div><div id="swipebox-action"><div id="desc_area"></div></div></div>';

		plugin.settings = {}

		plugin.init = function(){

			plugin.settings = $.extend({}, defaults, options);

			if ($.isArray(elem)) {

				elements = elem;
				ui.target = $(window);
				ui.init(plugin.settings.initialIndexOnArray);

			}else{

				$(selector).on('click', function(e){
					elements = [];
					var relType, relVal;

					if (!relVal) {
						relType = 'rel';
						relVal  = $(this).attr(relType);
					}

					if (relVal && relVal !== '' && relVal !== 'nofollow') {
						$elem = $(selector);
					}else{
						$elem = $(selector);
					}

					$($elem).each(function(){

						var title = null, href = null, album_photo_id = null, isVideo = false;
						
						if( $(this).attr('title') )
							title = $(this).attr('title');

						if( $(this).attr('href') )
							href = $(this).attr('href');
						if( $(this).attr('id') )
							album_photo_id = $(this).attr('id');

						var model = plugin.settings.collection.find(function(model) { return model.get('album_photo_id') == album_photo_id; })
						if (model && model.get('content_type') == 'video') {
							isVideo = true;
						}
						elements.push({
							album_photo_id: album_photo_id,
							href: href,
							title: title,
							isVideo: isVideo
						});
					});
					
					index = $($elem).index($(this));
					e.preventDefault();
					//e.stopPropagation();
					ui.target = $(e.target);
					ui.init(index);
				});
			}
		}

		plugin.refresh = function() {
			if (!$.isArray(elem)) {
				ui.destroy();
				$elem = $(selector);
				ui.reInit(index, true);
			}
		}

		plugin.destroy = function(){
			ui.destroy();
		}

		plugin.orientationchange = function() {
			ui.reInit(index, true);
		}

		var ui = {

			init : function(index){
				if (plugin.settings.beforeOpen) 
					plugin.settings.beforeOpen();
				this.target.trigger('swipebox-start');
				$.swipebox.isOpen = true;
				this.build();
				this.openSlide(index, false, true);
				this.openMedia(index);
				// this.preloadMedia(index+1);
				// this.preloadMedia(index-1);
			},
			reInit: function(index, reload) {
				this.setDim();
				this.openSlide(index, reload);
			},
			build : function(){
				var $this = this;

				$('body').append(html);

				if($this.doCssTrans()){
					$('#swipebox-slider').css({
						'-webkit-transition-duration': '0.4s',
						'-moz-transition-duration': '0.4s',
						'-o-transition-duration': '0.4s',
						'-ms-transition-duration': '0.4s',
						'transition-duration': '0.4s',
					});
					$('#swipebox-overlay').css({
						'-webkit-transition' : 'opacity 1s ease',
						'-moz-transition' : 'opacity 1s ease',
						'-o-transition' : 'opacity 1s ease',
						'-khtml-transition' : 'opacity 1s ease',
						'transition' : 'opacity 1s ease'
					});
					$('#swipebox-action, #swipebox-caption').css({
						'-webkit-transition' : '0.5s',
						'-moz-transition' : '0.5s',
						'-o-transition' : '0.5s',
						'-khtml-transition' : '0.5s',
						'transition' : '0.5s'
					});
				}


				// if(supportSVG){
				// 	var bg = $('#swipebox-caption #swipebox-close').css('background-image');
				// 	bg = bg.replace('png', 'svg');
				// 	$('#swipebox-caption #swipebox-prev,#swipebox-caption #swipebox-next,#swipebox-caption #swipebox-close').css({
				// 		'background-image' : bg
				// 	});
				// }
				
				// $.each( elements,  function(){
					$('#swipebox-slider').append('<div class="slide"></div>');
				// });

				$this.setDim();
				$this.actions();
				$this.keyboard();
				$this.gesture();
				$this.animBars();
				$this.resize();
				
			},

			setDim : function(){
				Pixlee.commands.execute("check:window");
				var width, height, sliderCss = {};
				if( "onorientationchange" in window ){
					width = gon.winWidth;
					height = gon.winHeight;
					winHeight = height;
					winWidth = width;
				}else{

					width = window.innerWidth ? window.innerWidth : $(window).width();
					height = window.innerHeight ? window.innerHeight : $(window).height();
					winHeight = height;
					winWidth = width;
				}
				sliderCss = {
					width : width,
					height : height
				}

				$('#swipebox-overlay').css(sliderCss);
				$('#swipebox-prev, #swipebox-next').css('top', (height/2 - 17) + 'px');

			},

			resize : function (){
				var $this = this;
				setTimeout(function(){
					$this.setDim();
				},2000);
				// $(window).resize(function() {
				// 	$this.setDim();
				// }).resize();
			},

			supportTransition : function() {
				var prefixes = 'transition WebkitTransition MozTransition OTransition msTransition KhtmlTransition'.split(' ');
				for(var i = 0; i < prefixes.length; i++) {
					if(document.createElement('div').style[prefixes[i]] !== undefined) {
						return prefixes[i];
					}
				}
				return false;
			},

			doCssTrans : function(){
				if(plugin.settings.useCSS && this.supportTransition() ){
					return true;
				}
			},

			gesture : function(){
				if ( isTouch ){
					var $this = this,
					distance = null,
					swipMinDistance = 10,
					startCoords = {},
					endCoords = {};
					var bars = $('#swipebox-caption, #swipebox-action');

					bars.addClass('visible-bars');
					$this.setTimeout();

           				}
			},

			setTimeout: function(){
				if(plugin.settings.hideBarsDelay > 0){
					var $this = this;
					$this.clearTimeout();
					$this.timeout = window.setTimeout( function(){
						$this.hideBars() },
						plugin.settings.hideBarsDelay
					);
				}
			},
			
			clearTimeout: function(){	
				window.clearTimeout(this.timeout);
				this.timeout = null;
			},

			showBars : function(){
				var bars = $('#swipebox-caption, #swipebox-action');
				if(this.doCssTrans()){
					bars.addClass('visible-bars');
				}else{
					$('#swipebox-caption').animate({ top : 0 }, 500);
					$('#swipebox-action').animate({ bottom : 0 }, 500);
					setTimeout(function(){
						bars.addClass('visible-bars');
					}, 1000);
				}
			},

			hideBars : function(){
				var bars = $('#swipebox-caption, #swipebox-action');
				if(this.doCssTrans()){
					bars.removeClass('visible-bars');
				}else{
					$('#swipebox-caption').animate({ top : '-50px' }, 500);
					$('#swipebox-action').animate({ bottom : '-50px' }, 500);
					setTimeout(function(){
						bars.removeClass('visible-bars');
					}, 1000);
				}
			},

			animBars : function(){
				var $this = this;
				var bars = $('#swipebox-caption, #swipebox-action');
					
				bars.addClass('force-visible-bars visible-bars');
				$this.setTimeout();
				
				$('#swipebox-slider').click(function(e){
					if(!bars.hasClass('visible-bars')){
						$this.showBars();
						$this.setTimeout();
					}
				});

				$('#swipebox-action').hover(function() {
				  		$this.showBars();
						bars.addClass('force-visible-bars');
						$this.clearTimeout();
					
					},function() { 
						// bars.removeClass('force-visible-bars');
						$this.setTimeout();

				});
			},

			keyboard : function(){
				var $this = this;
				$(window).bind('keyup', function(e){
					e.preventDefault();
					e.stopPropagation();
					if (e.keyCode == 37){
						$this.getPrev();
					}
					else if (e.keyCode==39){
						$this.getNext();
					}
					else if (e.keyCode == 27) {
						$this.closeSlide();
					}
				});
			},

			actions : function(){
				var $this = this;
				
				if( elements.length < 2 ){
					$('#swipebox-prev, #swipebox-next').hide();
				}else{
					$('#swipebox-prev').bind('touchstart', function(e){
						e.preventDefault();
						e.stopPropagation();
						$this.getPrev();
						$this.setTimeout();
					});
					
					$('#swipebox-next').bind('touchstart', function(e){
						e.preventDefault();
						e.stopPropagation();
						$this.getNext();
						$this.setTimeout();
					});
				}

				$('#swipebox-close').bind('touchstart', function(e){
					e.preventDefault();
					e.stopPropagation();
					$this.closeSlide();
				});
			},
			
			setSlide : function (index, isFirst, reload){
				isFirst = isFirst || false;
				
				var slider = $('#swipebox-slider');
				// if(this.doCssTrans()){
				// 	var prop = { 
				// 		'-webkit-transform' :  'translate3d(' + (-index*winWidth)+'px, 0px, 0px)',
				// 		'-moz-transform' :  'translate3d(' + (-index*winWidth)+'px, 0px, 0px)',
				// 		'-o-transform' :  'translate3d(' + (-index*winWidth)+'px, 0px, 0px)',
				// 		'-ms-transform' :  'translate3d(' + (-index*winWidth)+'px, 0px, 0px)',
				// 		'transform' :  'translate3d(' + (-index*winWidth)+'px, 0px, 0px)',
				// 	};
				// 	slider.css(prop);
				
					
				// }else{
				// 	slider.animate({ left : (-index*100)+'%' });
				// }
				if (plugin.settings.collection && !isFirst && !reload) {
					plugin.settings.model = plugin.settings.collection.find(function(model) { return model.get('album_photo_id') == elements[index].album_photo_id; });
					Pixlee.commands.execute("changed:photo", $('#desc_area'), plugin.settings.model.get('album_photo_id'));
				} else if (plugin.settings.model && isFirst && !reload) {
					Pixlee.commands.execute("changed:photo", $('#desc_area'), plugin.settings.model.get('album_photo_id'));
				}
				$('#swipebox-slider .slide').removeClass('current');
				$('#swipebox-slider .slide').addClass('current');
				this.setTitle(index);

				if( isFirst ){
					slider.show();
				}

				$('#swipebox-prev, #swipebox-next').removeClass('disabled');
				if(index == 0){
					$('#swipebox-prev').addClass('disabled');
				}else if( index == elements.length - 1 ){
					$('#swipebox-next').addClass('disabled');
				}
			},
		
			openSlide : function (index, reload , Initial){
				if (plugin.settings.collection && !plugin.settings.model) {
					plugin.settings.model = plugin.settings.collection.find(function(model) { return model.get('album_photo_id') == elements[index].album_photo_id; });
				}
				$('html').addClass('swipebox');
				$(window).trigger('resize'); // fix scroll bar visibility on desktop
				var _this = this;
				if (Initial) {
					setTimeout(function(){
						_this.setSlide(index, true, reload);
					},100);	
				} else {
					_this.setSlide(index, true, reload);
				}
				
			},
		
			preloadMedia : function (index){
				var $this = this, src = null;

				if( elements[index] !== undefined )
					src = elements[index].href;

				if(!elements[index].isVideo){
					setTimeout(function(){
						$this.openMedia(index);
					}, 1000);
				}else{
					$this.openMedia(index);
				}
			},
			
			openMedia : function (index){
				var $this = this, src = null;

				if( elements[index] !== undefined )
					src = elements[index].href;

				if(index < 0 || index >= elements.length){
					return false;
				}

				if(!elements[index].isVideo){
					$this.loadMedia(src, function(){
						$('#swipebox-slider .slide').html(this);
					});
				}else{
					$('#swipebox-slider .slide').html($this.getVideo(src));
				}
				
			},

			setTitle : function (index, isFirst){
				var title = null;

				//$('#swipebox-caption').empty();

				if( elements[index] !== undefined )
					title = elements[index].title;
				
				if(title){
					//$('#swipebox-caption').append(title);
				}
			},

			isVideo : function (index){

				// if( src ){
				// 	if( 
				// 		src.match(/youtube\.com\/watch\?v=([a-zA-Z0-9\-_]+)/) 
				// 		|| src.match(/vimeo\.com\/([0-9]*)/) 
				// 	){
				// 		return true;
				// 	}
				// } 
				if (elements && elements[index] && elements[index].isVideo) {
					return true;
				} else if (plugin.settings.model && plugin.settings.model.get('content_type') === 'video') {
					return true;
				} else {
					return false;
				}
					
			},

			getVideo : function(url){
				var iframe = '';
				var output = '';
				var youtubeUrl = url.match(/watch\?v=([a-zA-Z0-9\-_]+)/);
				var vimeoUrl = url.match(/vimeo\.com\/([0-9]*)/);
				if( youtubeUrl ){

					iframe = '<iframe width="560" height="315" src="//www.youtube.com/embed/'+youtubeUrl[1]+'" frameborder="0" allowfullscreen></iframe>';
				
				}else if(vimeoUrl){

					iframe = '<iframe width="560" height="315"  src="http://player.vimeo.com/video/'+vimeoUrl[1]+'?byline=0&amp;portrait=0&amp;color='+plugin.settings.vimeoColor+'" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
				
				} else {
					var src = plugin.settings.model.get('source_url').replace('http://', 'https://');
					// if(src.indexOf('static.pxlecdn.com') != -1)
					// {
					// 	src = src.replace('https://', 'https://s3.amazonaws.com/')
					// }
					iframe = '<video width="100%" height="100%" controls preload="auto" poster="'+url+'"><source src="' + src+'" type="video/mp4"></video>';
				}

				return '<div class="swipebox-video-container" style="max-width:'+plugin.settings.videomaxWidth+'px"><div class="swipebox-video">'+iframe+'</div></div>';
			},
			
			loadMedia : function (src, callback){
				if( !this.isVideo(src) ){
					var img = $('<img>').on('load', function(){
						callback.call(img);
					});
					
					img.attr('src',src);
				} else {
					$('#swipebox-slider .slide').html(this.getVideo(src));
				}
			},
			
			getNext : function (){
				var $this = this;
				var ind  = index;
				if(ind+1 < elements.length){
					index++;
					$this.setSlide(index);
					$this.openMedia(index);
				}
				else{
					
					$('#swipebox-slider').addClass('rightSpring');
					setTimeout(function(){
						$('#swipebox-slider').removeClass('rightSpring');
					},500);
				}
			},
			
			getPrev : function (){
				var ind  = index;
				if(ind > 0){
					index--;
					this.setSlide(index);
					this.openMedia(index);
				}
				else{
					
					$('#swipebox-slider').addClass('leftSpring');
					setTimeout(function(){
						$('#swipebox-slider').removeClass('leftSpring');
					},500);
				}
			},


			closeSlide : function (){
				$('html').removeClass('swipebox');
				$(window).trigger('resize');
				this.destroy();
			},

			destroy : function(){
				$(window).unbind('keyup');
				$('body').unbind('touchstart');
				$('body').unbind('touchmove');
				$('body').unbind('touchend');
				$('#swipebox-slider').unbind();
				$('#swipebox-overlay').remove();
				if (!$.isArray(elem))
					elem.removeData('_swipebox');
				if ( this.target )
					this.target.trigger('swipebox-destroy');
				$.swipebox.isOpen = false;
				if (plugin.settings.afterClose) 
					plugin.settings.afterClose();
 			}

		};

		plugin.init();
		
	};

	$.fn.swipebox = function(options){
		// if (!$.data(this, "_swipebox")) {
			$(options.$selectedElem).off('click');
			$(options.$selectedElem).removeData('_swipebox');
			var swipebox = new $.swipebox($(options.$selectedElem), options);
			$(options.$selectedElem).data('_swipebox', swipebox);
		// }
		return $(options.$selectedElem).data('_swipebox');
	}

}(window, document, jQuery));
